export class TreatmentRegisterLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            // description: lang.deadline[0],
            no:"No",
            code:lang.privacy[0],
            desc_of_treatment:lang.privacy[1],
            purpose:lang.privacy[2],
            type:lang.privacy[3],
            tools_data_processing:lang.privacy[4],
            physical_location_data_storage:lang.privacy[5],
            type_access_computer_data:lang.privacy[6],
            physical_location_data_archieve:lang.privacy[7],
            type_access_papper_data:lang.privacy[8],
            select_type:lang.privacy[9],
            treatment_creation:lang.privacy[10],
            privacy:lang.general[113],
            treatment_register:lang.general[114],
            requiredField: lang.general[26],
            selectAll: lang.general[10],
            selectColumns: lang.general[9],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            close: lang.general[17],
            save: lang.general[0],
            action: lang.general[117],
            modify: lang.general[2],
            erase: lang.general[4],
            common_data:lang.privacy[28],
            sensitive_data:lang.privacy[29],
            electronic:lang.privacy[30],
            paper:lang.privacy[31],
            search: lang.general[33],
            name:lang.privacy[32],
            function:lang.privacy[33],
            type_of_function:lang.privacy[34],
            treatment_carried_out:lang.privacy[35],
            desc_of_assigned_tasks:lang.privacy[36],
            desc_of_responsiblties:lang.privacy[37],
            appointment_data_processor:lang.general[115],


                   
           

        }

    }

    lang() {
        return this.variables;
    }

}
